/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import useCustomMutationReactQuery from '../generalHooks/useCustomMutationReactQuery'
import { getUserList, updatePostById } from '../../apiProcess/sampleApi'
import _ from 'lodash'
import { loginProcess, otpProcess } from '@/utility/apiProcess/auth/login'
import { toast } from 'react-toastify'
import { getUpcomingEvents } from '@/utility/apiProcess/events'
import { getListCareer } from '@/utility/apiProcess/career'
import { getDetailFaqList, getFaqByTopic, getFaqTopics } from '@/utility/apiProcess/help-center'
import { getLanguage } from '@/utility/helper/generalHandler'

const useHelpCenterQuery = () => {
  // get faq topics
	const [faqTopics, setFaqTopics] = useState<any>([])
  const {
		isLoading: loadingFaqTopics,
		return_data: rawFaqTopics,
		startFetch: startFaqTopics,
	} = useCustomMutationReactQuery(getFaqTopics, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: false,
	})

	useEffect(() => {
		if (!_.isEmpty(rawFaqTopics)) {
			const language = getLanguage()
			const data:any = []
			rawFaqTopics.data.data.map((item: any, index:number) => {
				data.push({
					id: item.id,
					label: item.name,
					img: item.image_url,
					isActive: index === 0 ? true : false,
				})
			})
			setFaqTopics(data)
			startFaqByTopic({id: data[0].id, lang: language})
		}
	},[rawFaqTopics])

	const handleChangeTopic = (id: number) => {
		const cloneFaqTopics = _.cloneDeep(faqTopics)
		cloneFaqTopics.map((item: any) => {
			item.isActive = item.id === id ? true : false
			if(item.id === id) {
				startFaqByTopic({id: item.id})
			}
		})
		setFaqTopics(cloneFaqTopics)
	}

	// get by topic
	const [faqByTopic, setFaqByTopic] = useState<any>([])
  const {
		isLoading: loadingFaqByTopic,
		return_data: rawFaqByTopic,
		startFetch: startFaqByTopic,
	} = useCustomMutationReactQuery(getFaqByTopic, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: false,
	})

	useEffect(() => {
		if (!_.isEmpty(rawFaqByTopic)) {
			const data:any = []
			console.log(rawFaqByTopic)
			rawFaqByTopic.data.data.map((item: any, index:number) => {
				data.push({
					id: item.id,
					label: item.question,
				})
			})
			setFaqByTopic(data)
		}
	},[rawFaqByTopic])

	// get detail faq list
	const [detailFaq, setDetailFaq] = useState<any>({
		other: []
	})
  const {
		isLoading: loadingDetailFaq,
		return_data: rawDetailFaq,
		startFetch: startDetailFaq,
	} = useCustomMutationReactQuery(getDetailFaqList, {
		onError: (error: Error) => console.log(error),
    isStartOnInit: false,
	})

	useEffect(() => {
		if (!_.isEmpty(rawDetailFaq)) {
			setDetailFaq(rawDetailFaq.data.data)
		}
	},[rawDetailFaq])

	return {
    loadingFaqTopics,
    faqTopics,
    startFaqTopics,
		handleChangeTopic,
		faqByTopic,
		startDetailFaq,
		detailFaq,
		startFaqByTopic,
		loadingDetailFaq
	}
}

export default useHelpCenterQuery
